module.exports = __webpack_public_path__ + "logo-f4b5cdb86b13079e61efd3bf2226b910.png";